module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/33b488e871c3b0653efb694b74dca255.png";